/**
 * Trodo theme for Analytics (light mode).
 * Brand primary is defined in shared/theme/trodoColors.js only.
 */
import {
  primary,
  primaryLight,
  primaryHover,
  primaryAlpha,
} from "shared/theme/trodoColors";

export const trodoAnalyticsTheme = {
  primary,
  primaryLight,
  primaryHover,
  secondary: "#caa968", // Muted Gold

  // Light UI — clean white/grey neutrals
  bgBase: "var(--surface-sunken)",
  bgRaised: "var(--surface-base)",
  bgOverlay: "var(--surface-sunken)",
  border: "var(--border-default)",
  borderMuted: "rgba(0,0,0,0.06)",

  // Text — clean ink + muted grey
  textPrimary: "var(--text-primary)",
  textSecondary: "var(--text-muted)",
  textMuted: "var(--text-disabled)",

  // Accents
  accentPositive: "#059669",
  accentChart: primary,
  accentChartMuted: primaryAlpha(0.5),
};
